// Chargement paresseux du SDK Firebase (uniquement si la config est remplie).
// Tant que ce n'est pas le cas, l'app tourne en mode local et ne télécharge rien.

const VERSION = "10.12.5";
const CDN = `https://www.gstatic.com/firebasejs/${VERSION}/`;

export function configured() {
  const c = window.FIREBASE_CONFIG || {};
  return Boolean(c.apiKey && c.projectId);
}

// App Check — atteste que la requête vient bien de CETTE application, et non
// d'un script qui a recopié la clé publique. Il ne s'active que si une clé
// reCAPTCHA est fournie : sans elle, on ne charge même pas le module.
//
// ⚠️ À lire avant d'activer l'application forcée dans la console : reCAPTCHA
// n'atteste que les domaines déclarés. L'APK, lui, sert ses pages depuis
// `https://localhost` — un domaine qu'on ne peut pas déclarer. Forcer App Check
// couperait donc l'application du téléphone. Voir SECURITE-SERVEUR.md.
async function attesterApplication(application) {
  const cle = (window.FIREBASE_CONFIG || {}).appCheckKey;
  if (!cle) return;
  try {
    const AC = await import(CDN + "firebase-app-check.js");
    if (window.APPCHECK_DEBUG) self.FIREBASE_APPCHECK_DEBUG_TOKEN = window.APPCHECK_DEBUG;
    /* ⚠️ ENTERPRISE, ET NON `ReCaptchaV3Provider` — et ce n'est pas un choix.
       Google a changé son formulaire : celui qui porte un sélecteur « Google
       Cloud Platform » et parle de « Fraud Defense » crée désormais des clés
       ENTERPRISE, même quand on coche « Sur la base d'un score (v3) ». Ces
       clés-là ne fonctionnent qu'avec `enterprise.js` ; le v3 classique les
       rejette avec « Invalid site key », et l'échange App Check répond 400.

       C'est mesuré, pas supposé : avec la même clé, `grecaptcha.execute` du v3
       classique n'a jamais rendu de jeton, et `grecaptcha.enterprise.execute`
       en a rendu un de 2190 caractères du premier coup.

       Conséquence côté console : l'application doit être enregistrée sous
       « reCAPTCHA Enterprise », PAS sous « reCAPTCHA v3 ». Enterprise ne
       demande d'ailleurs aucune clé secrète — seulement l'identifiant de la
       clé, qui est la clé de site elle-même. */
    AC.initializeAppCheck(application, {
      provider: new AC.ReCaptchaEnterpriseProvider(cle),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // Une attestation qui échoue ne doit jamais fermer l'application à ses
    // membres : tant que l'application forcée n'est pas activée côté console,
    // les requêtes passent quand même.
    console.warn("App Check indisponible :", e?.message || e);
  }
}

let _sdk = null;

export async function sdk() {
  if (_sdk) return _sdk;
  const [app, auth, db, storage] = await Promise.all([
    import(CDN + "firebase-app.js"),
    import(CDN + "firebase-auth.js"),
    import(CDN + "firebase-firestore.js"),
    import(CDN + "firebase-storage.js"),
  ]);
  const application = app.initializeApp(window.FIREBASE_CONFIG);
  await attesterApplication(application);
  _sdk = {
    A: auth,
    D: db,
    S: storage,
    auth: auth.getAuth(application),
    db: db.getFirestore(application),
    storage: storage.getStorage(application),
  };
  return _sdk;
}
